<template>
  <v-row>
    <v-col
      cols="12"
      sm="3"
      md="3"
      lg="3"
      xl="3"
      v-for="(value, key) of data"
      :key="key"
      >
      <StreamfieldBlock v-for="(block, i) in value" :key="i" :block="block"/>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "FourColumnBlock",
  props: ["data"],
  beforeCreate: function () {
    //Prevents recustive importing...
    this.$options.components.StreamfieldBlock = require('../streamfieldBlock.vue').default
  }
};
</script>

<style scoped>
</style>